@if (isLoading) {
  <div
    class="flex justify-center items-center w-full h-full"
    >
    <p-progressSpinner></p-progressSpinner>
  </div>
} @else {
  <p-table
    class="flex card-tab-widget"
    responsiveLayout="scroll"
    dataKey="weekNumber"
    rowExpandMode="single"
    [columns]="tableCols"
    [value]="iterationData"
    >
    <ng-template let-columns pTemplate="header">
      <tr>
        @for (column of tableCols; track column) {
          <th
            [style]="{ 'width': column.width }"
            >
            {{ column.header }}
          </th>
        }
      </tr>
    </ng-template>
    <ng-template let-item let-expanded="expanded" pTemplate="body">
      <tr [pSelectableRow]="item">
        @for (column of tableCols; track column) {
          <td>
            @switch (column.field) {
              @case ('expand') {
                <ng-container class="w-full text-center">
                  <button
                    type="button"
                    class="p-button-text p-button-rounded"
                    pButton
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    (click)="onRowExpand(item, expanded)"
                  ></button>
                </ng-container>
              }
              @case ('weekNumber') {
                Week {{ item.weekNumber }}
              }
              @case ('period') {
                {{ item.startDate | utcDateWithoutTimeZone: 'MM/dd/yyyy'  }} - {{ item.endDate | utcDateWithoutTimeZone: 'MM/dd/yyyy'  }}
              }
              @default {
                {{ item.totalMinutes[column.field] }}
              }
            }
          </td>
        }
      </tr>
    </ng-template>
    <ng-template let-item let-rowIndex="rowIndex" #expandedrow>
      <tr>
        <td class="p-4" [attr.colspan]="tableCols.length + 1">
          <therapy-minutes-expanded
            [eligibleDatesForTherapy]="eligibleDatesForTherapy"
            [canEdit]="canEdit"
            [previousPeriod]="rowIndex > 0 ? iterationData[rowIndex - 1] : null"
            [currentPeriod]="item"
            [disciplines]="disciplines"
            [tenantId]="tenantId"
            [authorizationByProductId]="authorizationByProductId"
            [isInternal]="isInternal"
            (updateMinutes)="minutesUpdates($event)"
            />
          </td>
        </tr>
      </ng-template>
    </p-table>
  }


  <p-toast key="therapy-minutes" position="bottom-left"></p-toast>
